<template>
  <div class="plan-upgrade-payment-component">
    <template v-if="isSuccess">
      <el-row class="m-0 bg-[#08a16a]/20 payment-success">
        <el-col :span="24" class="flex items-start justify-center flex-col">
          <div class="flex items-center justify-start px-10 py-12">
            <font-awesome-icon icon="fa-regular fa-circle-check" class="text-[#08a16a] text-3xl"/>
            <h2 class="text-lg font-medium text-[#08a16a] block capitalize ml-5">{{$t('planUpgrade.paymentSuccessful')}}</h2>
          </div>
        </el-col>
      </el-row>

      <p class="text-4xl text-center p-12 font-semibold text-[#23569F] block">{{$t('planUpgrade.welcomeToPremium')}}</p>
  </template>

  <template v-if="isFailed">
      <el-row class="m-0 bg-[#F46D6D]/20 payment-failed">
        <el-col :span="24" class="flex items-start justify-center flex-col">
          <div class="flex items-center justify-start px-10 py-12">
            <font-awesome-icon icon="fa-regular fa-circle-xmark" class="text-[#F46D6D] text-3xl"/>
            <h2 class="text-lg font-medium text-[#F46D6D] block ml-5">{{$t('planUpgrade.paymentFailed')}}</h2>
          </div>
        </el-col>
      </el-row>
  </template>
  </div>
</template>

<script src="./plan-upgrade-payment.js"></script>
<style lang="scss" src="./plan-upgrade-payment.scss"></style>
